/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Icon95IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Icon95Icon(props: Icon95IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 32 32"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M23 8V2H2v24h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h23a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0"
        }
      ></path>

      <path
        fill={"currentColor"}
        d={
          "M19 20.743a1 1 0 1 1 2 0v7.639l2.553-1.277a1 1 0 0 1 .894 0L27 28.382v-7.639a1 1 0 1 1 2 0V30a1 1 0 0 1-1.447.894L24 29.118l-3.553 1.776A1 1 0 0 1 19 30z"
        }
      ></path>

      <path
        fill={"currentColor"}
        d={
          "M30 15a6 6 0 1 0-12 0 6 6 0 0 0 12 0m2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0M14 8a1 1 0 1 1 0 2H6a1 1 0 0 1 0-2zm-2 5a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2zm0 5a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2z"
        }
      ></path>
    </svg>
  );
}

export default Icon95Icon;
/* prettier-ignore-end */
